import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import ContentTitle from "components/common/ContentTitle";
import ButtonController from "components/request-document/components/ButtonController";
import { useStyles } from "components/request-document/components/Commons";
import VisaIssuanceSection from "components/request-document/components/VisaIssuanceSection";
import { useFormik } from "formik";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getBranchList } from "redux/modules/branchSlice";
import { getMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { selectIsChamber } from "redux/modules/smartCompanySlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  addSmartfromExtension,
  getSmartForm,
  getSmartFormFieldConfig,
  getVisaRequest,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function VisaIssuanceStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const isChamber = useSelector(selectIsChamber);

  const personalId = get(personalDetail, "personalID", "");
  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );

  const isExtension = smartform.typeDocSmartFromName === "Extension";
  const ConditionType = get(smartformDetail, "ConditionType.value", "");
  const isCOMP = ConditionType === "COMP"; // ส่งเสริม
  const isINVP = ConditionType === "INVP"; // ศึกษาลู่ทาง
  const isINVPOnlyThai =
    isINVP &&
    smartform.visaRequestID === "812cb59e-f79e-4445-9348-fa0e1e448499";
  const isINVPOverseas =
    isINVP &&
    smartform.visaRequestID === "f4e46279-2f64-4428-a7ea-9062b9baf334";

  useEffect(() => {
    dispatch(
      getMasterData({
        CountryConfig: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getBranchList({
        isThailand: isChamber || isCOMP || isINVPOnlyThai,
        allStatus: false,
      })
    );
  }, [isChamber || isCOMP || isINVPOnlyThai]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
    dispatch(getVisaRequest({ smartserviceId: smartServiceId }));
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance } = values;

    const prepareData = {
      ...smartform,
      // draftId: draftId || null,
      // smartserviceId: smartServiceId,
      // personalId: personalId,
      // survey: null,
      visaissuance: {
        visaInssuanceId: visaissuance.visaInssuanceId || null,
        overseas: visaissuance.overseas || null,
        thailand: visaissuance.thailand || null,
        countryId: visaissuance.countryId || null,
        branchID: visaissuance.branchID || null,
        dateofArrival: visaissuance.dateofArrival || null,
        untilDate: visaissuance.untilDate || null,
      },
      visaRequestID: smartform.visaRequestID || null,
      detail: [],
    };

    if (isExtension) {
      await dispatch(
        addSmartfromExtension({
          data: prepareData,
        })
      );
    } else {
      await dispatch(
        addSmartForm({
          data: prepareData,
        })
      );
    }
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      visaissuance: {
        visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
        overseas: get(
          smartform,
          "visaissuance.overseas",
          isINVPOverseas || true
        ),
        thailand: get(
          smartform,
          "visaissuance.thailand",
          isChamber || isCOMP || isINVPOnlyThai
        ),
        countryId: get(smartform, "visaissuance.countryId", ""),
        branchID: get(smartform, "visaissuance.branchID", ""),
        dateofArrival: get(smartform, "visaissuance.dateofArrival", null),
        untilDate: get(smartform, "visaissuance.untilDate", null),

        // oneStopService: get(smartform, "visaissuance.oneStopService", false),
        // eec: get(smartform, "visaissuance.eec", false),
        // visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
        // visaExp: get(smartform, "visaissuance.visaExp", ""),
      },
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION FOREIGN EXPERTS OR TECHNICIAN UNDER SECTION 24 "
        />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <VisaIssuanceSection
              colSpan={4}
              formik={formik}
              hideOverseas={isChamber || isCOMP || isINVPOnlyThai}
              hideThailand={isINVPOverseas}
            />
          </Table>
        </TableContainer>

        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
